// extracted by mini-css-extract-plugin
export default {"inlineReviewThreadHeading":"InlineReviewThread-module__inlineReviewThreadHeading--CroDZ"};